import React from 'react';
import { ApolloProvider, useQuery } from '@apollo/client';
import { IntlProvider, useIntl } from 'react-intl';
import gql from 'graphql-tag';
import client from '../../../../lib/apolloClient';
import translations from '../../../../lib/i18n/translations.json';
import SuccessionCfaWizard from '../components/wizard/SuccessionCfaWizard';

const GET_SUCCESSION_CFA_WIZARD_DATA = gql`
  query GetSuccessionCfaWizardData {
    getCurrentUser {
      id
      name
      email
      company {
        id
        name
        display_name
        host
        cash_flow_analysis_word
        cash_flow_analysis_word_fr
        features
      }
    }
  }
`;

const SuccessionCfaWizardInner = () => {
  const intl = useIntl();
  const { loading, error, data } = useQuery(GET_SUCCESSION_CFA_WIZARD_DATA);

  if (loading) return <div className="flex items-center justify-center min-h-screen"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div></div>;
  if (error) return <div className="flex items-center justify-center min-h-screen text-red-600">{intl.formatMessage({ id: 'succession.cash_flow_analysis.container.error_loading' })}</div>;
  return <SuccessionCfaWizard currentUser={data.getCurrentUser} />;
};

const SuccessionCfaWizardContainer = (props, railsContext) => {
  window.locale = (railsContext && railsContext.i18nLocale) || window.locale || 'en';
  const locale = window.locale;
  
  return (
    <ApolloProvider client={client}>
      <IntlProvider locale={locale} messages={translations[locale] || translations.en}>
        <SuccessionCfaWizardInner />
      </IntlProvider>
    </ApolloProvider>
  );
};

export default SuccessionCfaWizardContainer; 